<template>
  <div>
  <Navbar />
  <v-row>
    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="pa-14 ma-14">
      <h1 class="font-weight-regular display-2 pink--text text--darken-2">Cinnamon Raisin Bagel</h1>
      <h3 class="font-weight-regular pink--text text--darken-2 mt-2">$50.00</h3>
      <v-btn class="mt-10 pink--text text--darken-2" large outlined width="320px" tile><h5>add to cart</h5></v-btn>
      <h4 class="mt-5 font-weight-regular pink--text text--lighten-2">Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Aspernatur sapiente voluptas deserunt magnam nihil iure,
        numquam rerum maxime nostrum hic animi unde consequuntur
        quod odit explicabo inventore nulla reiciendis enim.</h4>
    </v-col>

     <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="pa-14 ma-14">
      <img class="pt-1" :src="require('../../assets/raisinbagel.jpeg')" height="400"/>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import Navbar from '../../components/detailspage/Navbar.vue'
export default {
  components: { Navbar },

}
</script>

<style>

</style>